<template>
  <div
    :class="[$style.box]"
  >
    <img

      src="@/assets/icon.png"
      :class="[$style.logo]"
    >
  </div>
</template>

<script>
export default {
  name: 'Footer'

}
</script>

<style module>
.box{
  position: relative;
  background: #F9F9F9;
  /* height: 240px; */
  padding: 48px;
  text-align: center;
}

.logo {
  width: 41px;
  height: 43px;
  margin: auto 0;
}

</style>
